/**
 *
 * @param key
 * @returns {any}
 */
export function get(key) { return JSON.parse(localStorage.getItem(key)) }

/**
 *
 * @param key
 * @param data
 */
export function set(key, data) { localStorage.setItem(key, JSON.stringify(data)) }

/**
 *
 * @param key
 * @param data
 */
export function update(key, data) {
	set(key, {
		...JSON.parse(localStorage.getItem(key)),
		...data
	})
}


//EOF//